__turbopack_context__.v({
  "Icon": "LocationsDropdown-module-scss-module__A_h5Yq__Icon",
  "List": "LocationsDropdown-module-scss-module__A_h5Yq__List",
  "LocationVisible": "LocationsDropdown-module-scss-module__A_h5Yq__LocationVisible",
  "Name": "LocationsDropdown-module-scss-module__A_h5Yq__Name",
  "Title": "LocationsDropdown-module-scss-module__A_h5Yq__Title",
});
